
const GraphSvg = () => {
  const strokeColor = "var(--background-site)";
  return (
    <svg
      style={{
        minHeight: "102%",
        minWidth: "102%",
        aspectRatio: "1495 / 754",
        overflow: "hidden",
        position: "relative",
        left: "100%",
        transform: "translateX(-99%)",
      }}
      viewBox="0 0 1495 754"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="153.5" cy="658.5" r="12.5" fill={strokeColor} />
      <circle cx="1086.5" cy="679.5" r="12.5" fill={strokeColor} />
      <circle cx="1375.5" cy="474.5" r="12.5" fill={strokeColor} />
      <circle cx="1150.5" cy="215.5" r="12.5" fill={strokeColor} />
      <circle cx="569.5" cy="174.5" r="12.5" fill={strokeColor} />
      <circle cx="194.5" cy="269.5" r="12.5" fill={strokeColor} />
      <circle cx="235.5" cy="474.5" r="12.5" fill={strokeColor} />
      <circle cx="569.5" cy="638.5" r="12.5" fill={strokeColor} />
      <circle cx="378.5" cy="719.5" r="12.5" fill={strokeColor} />
      <circle cx="825.5" cy="740.5" r="12.5" fill={strokeColor} />
      <circle cx="1334.5" cy="658.5" r="12.5" fill={strokeColor} />
      <circle cx="1334.5" cy="269.5" r="12.5" fill={strokeColor} />
      <circle cx="895.5" cy="154.5" r="12.5" fill={strokeColor} />
      <circle cx="1269.5" cy="133.5" r="12.5" fill={strokeColor} />
      <circle cx="1452.5" cy="379.5" r="12.5" fill={strokeColor} />
      <circle cx="337.5" cy="133.5" r="12.5" fill={strokeColor} />
      <circle cx="113.5" cy="154.5" r="12.5" fill={strokeColor} />
      <circle cx="104.5" cy="419.5" r="12.5" fill={strokeColor} />
      <circle cx="721.5" cy="78.5" r="12.5" fill={strokeColor} />
      <circle cx="1008.5" cy="296.5" r="12.5" fill={strokeColor} />
      <circle cx="1086.5" cy="78.5" r="12.5" fill={strokeColor} />
      <circle cx="1219.5" cy="543.5" r="12.5" fill={strokeColor} />
      <path
        d="M1217.83 546.283L1333.81 659.726"
        stroke={strokeColor}
        strokeWidth="4"
      />
      <path
        d="M1007.73 295.489L1082 80.8135"
        stroke={strokeColor}
        strokeWidth="4"
      />
      <path
        d="M1085.05 79.2868L894.286 158.137L719.799 79.2868L753.374 1.96289"
        stroke={strokeColor}
        strokeWidth="4"
      />
      <path
        d="M104.769 418.596L111.382 156.102L193.284 270.562L339.793 133.719L571.765 176.45L895.304 156.102L1151.69 219.691L1270.22 133.719L1335.34 270.562L1376.04 476.081L1335.34 661.76L1087.09 683.126L571.765 637.851L155.64 661.76L104.769 418.596Z"
        stroke={strokeColor}
        strokeWidth="4"
      />
      <path
        d="M233.98 476.59L380.489 724.84L568.203 639.377L823.576 742.137L1086.07 682.109L1370.44 476.59"
        stroke={strokeColor}
        strokeWidth="4"
      />
      <path
        d="M1454.38 382.987L1151.19 218.674"
        stroke={strokeColor}
        strokeWidth="4"
      />
      <path
        d="M1376.04 478.624L1453.87 380.443"
        stroke={strokeColor}
        strokeWidth="4"
      />
      <path
        d="M237.033 477.098L100.698 419.105"
        stroke={strokeColor}
        strokeWidth="4"
      />
      <path
        d="M238.05 471.503L337.757 136.263"
        stroke={strokeColor}
        strokeWidth="4"
      />
      <path
        d="M194.81 270.054L1.5 303.629"
        stroke={strokeColor}
        strokeWidth="4"
      />
      <path
        d="M151.57 660.743L1.5 587.997"
        stroke={strokeColor}
        strokeWidth="4"
      />
      <path
        d="M236.016 476.081L220.754 765.537"
        stroke={strokeColor}
        strokeWidth="4"
      />
      <path
        d="M1087.09 681.6L1128.8 765.028"
        stroke={strokeColor}
        strokeWidth="4"
      />
      <path
        d="M1220.37 548.317L1287.01 765.537"
        stroke={strokeColor}
        strokeWidth="4"
      />
      <path
        d="M1374 474.046L1520 498.973"
        stroke={strokeColor}
        strokeWidth="4"
      />
      <path
        d="M1336.87 269.036L1520 236.479"
        stroke={strokeColor}
        strokeWidth="4"
      />
      <path
        d="M718.782 76.2344L337.249 132.701"
        stroke={strokeColor}
        strokeWidth="4"
      />
      <path
        d="M377.946 722.297L149.535 659.217"
        stroke={strokeColor}
        strokeWidth="4"
      />
      <path
        d="M1007.22 298.541L1147.62 218.165"
        stroke={strokeColor}
        strokeWidth="4"
      />
      <path
        d="M1085.56 77.2517L1023.5 6.03223"
        stroke={strokeColor}
        strokeWidth="4"
      />
      <path
        d="M1270.73 132.193L1354.16 1.96289"
        stroke={strokeColor}
        strokeWidth="4"
      />
    </svg>
  );
};

export default GraphSvg;
